import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LoadingState } from "@/components/StateViews";

export function ProtectedRoute({ children }) {
  const { user, isChecking } = useAuth();
  if (isChecking) return <LoadingState label="Checking session..." />;
  if (!user) return <Navigate to="/" replace />;
  return children;
}
